import React, { Component } from 'react';
import { getMultiLang } from '@platform/api';

class Wrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            refName: props.refName,
            placeholder: props.placeholder,
            rootNode: props.rootNode,
            columnConfig: props.columnConfig,
            dropDownTitleConfig: props.dropDownTitleConfig,
            treeConfig: props.treeConfig,
            addButtons: props.addButtons,
        };
    }

    componentWillMount() {
        const { multiLang } = this.props;

        if (multiLang) {
            let { moduleId, currentLocale, domainName } = multiLang;
            this.getMultiLangJSON(
                moduleId,
                currentLocale,
                domainName,
                this.props
            );
        }
    }

    getMultiLangJSON = (moduleId, currentLocale, domainName, props) => {
        getMultiLang({
            moduleId,
            currentLocale,
            domainName,
            callback: (json) => {
                this.propsToState(props, json);
            },
        });
    };

    //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
    componentWillReceiveProps(nextProps) {
        const { multiLang: nextMultiLang, refcode: nextRefcode } = nextProps;
        const { multiLang, refcode } = this.props;
        if (nextMultiLang && multiLang) {
            // eslint-disable-next-line one-var-declaration-per-line
            let moduleId, currentLocale, domainName;
            if (multiLang) {
                ({ moduleId, currentLocale, domainName } = multiLang);
            }
            const {
                moduleId: nextModuleId,
                currentLocale: nextCurrentLocale,
                domainName: nextDomainName,
            } = nextMultiLang;
            if (
                moduleId !== nextModuleId ||
                currentLocale !== nextCurrentLocale ||
                domainName !== nextDomainName ||
                refcode !== nextRefcode
            ) {
                this.getMultiLangJSON(
                    nextModuleId,
                    nextCurrentLocale,
                    nextDomainName,
                    nextProps
                );
            } else {
                this.propsToState(nextProps, this.state.json);
            }
        } else {
            this.setState({
                refName: nextProps.refName,
                placeholder: nextProps.placeholder,
                rootNode: nextProps.rootNode,
                columnConfig: nextProps.columnConfig,
                dropDownTitleConfig: nextProps.dropDownTitleConfig,
                treeConfig: nextProps.treeConfig,
                addButtons: nextProps.addButtons,
            });
        }
    }

    propsToState = (props, json) => {
        const {
            refName: _refName,
            placeholder: _placeholder,
            rootNode: _rootNode,
            columnConfig: _columnConfig,
            dropDownTitleConfig: _dropDownTitleConfig,
            treeConfig: _treeConfig,
            addButtons: _addButtons,
        } = props;
        let {
            refName,
            placeholder,
            rootNode,
            columnConfig,
            dropDownTitleConfig,
            treeConfig,
            addButtons,
        } = this.state;
        // refName
        refName = json[_refName] || _refName;
        // placeholder
        placeholder = json[_placeholder] || _placeholder;
        // columnConfig
        Array.isArray(_columnConfig) &&
            (columnConfig = _columnConfig.map((column) => {
                column.name = (column.name || []).map(
                    (name) => json[name] || name
                );
                return column;
            }));
        // dropDownTitleConfig
        Array.isArray(_dropDownTitleConfig) &&
            (dropDownTitleConfig = _dropDownTitleConfig.map((column) => {
                column.name = (column.name || []).map(
                    (name) => json[name] || name
                );
                return column;
            }));
        // treeConfig
        if (_treeConfig) {
            _treeConfig.name = (_treeConfig.name || []).map(
                (name) => json[name] || name
            );
            treeConfig = _treeConfig;
        }
        // rootNode
        if (_rootNode) {
            rootNode = rootNode || {};
            Object.keys(_rootNode).forEach((e) => {
                rootNode[e] = json[_rootNode[e]] || _rootNode[e];
            });
        } else {
            rootNode = null;
        }

        // addButtons
        if (Array.isArray(_addButtons)) {
            addButtons = _addButtons.map((button) => {
                button.name = json[button.name] || button.name;
                return button;
            });
        }
        this.setState({
            json,
            refName,
            placeholder,
            rootNode,
            columnConfig,
            dropDownTitleConfig,
            treeConfig,
            addButtons,
        });
    };

    mergeColumn = (columnConfig, items) => {
        let attrcodeArr = new Set(),
            labelArr = new Set(),
            widthMap = {},
            itemtypeMap = {},
            colorMap = {},
            fullTxtCodeMap = {},
            searchMap = {};
        // totalMap = {};
        items.forEach((item) => {
            let {
                attrcode,
                label,
                width = 150,
                visible,
                itemtype,
                contentcolor,
                // isTotal = false,
            } = item;
            if (visible && !attrcodeArr.has(attrcode)) {
                attrcodeArr.add(attrcode);
                labelArr.add(label);
                widthMap[attrcode] = width;
                itemtypeMap[attrcode] = itemtype;
                colorMap[attrcode] = contentcolor;
                fullTxtCodeMap[attrcode] = true;
                searchMap[attrcode] = true;
                // totalMap[attrcode] = isTotal;
            }
        });
        if (columnConfig && Array.isArray(columnConfig)) {
            columnConfig = columnConfig.map(
                ({
                    name,
                    code,
                    width,
                    fullTxtCode,
                    search,
                    contentcolor,
                    // total,
                }) => {
                    let column = {};
                    column.name = [...(name || []), ...labelArr];
                    column.code = [...(code || []), ...attrcodeArr];
                    column.width = Object.assign(width || {}, widthMap);
                    // column.total = Object.assign(total || {}, totalMap);

                    column.itemtype = Object.assign({}, itemtypeMap); //给每个字段配置显示样式
                    column.contentcolor = Object.assign(
                        contentcolor || {},
                        colorMap
                    );
                    search && (column.search = { ...search });
                    fullTxtCode && (column.fullTxtCode = { ...fullTxtCode });
                    // column.fullTxtCode = Object.assign(
                    //     fullTxtCode || {},
                    //     fullTxtCodeMap
                    // );

                    // column.search = Object.assign(search || {}, searchMap);

                    return column;
                }
            );
        } else {
            columnConfig = [
                {
                    name: [...labelArr],
                    code: [...attrcodeArr],
                    width: widthMap,
                    itemtype: itemtypeMap,
                    contentcolor: colorMap,
                    // total: totalMap,
                    // fullTxtCode: fullTxtCodeMap,
                    // search: searchMap,
                },
            ];
        }
        return columnConfig;
    };

    render() {
        let {
            refName,
            placeholder,
            rootNode,
            columnConfig,
            dropDownTitleConfig,
            treeConfig,
            addButtons,
            json,
        } = this.state;
        const { App, loadColumns, ...others } = this.props;
        //mergeColumn
        if (columnConfig && columnConfig[0] && !columnConfig[0].fullTxtCode) {
            columnConfig[0]['fullTxtCode'] = {
                refcode: true,
                refname: true,
            };
            columnConfig[0]['search'] = {
                refcode: true,
                refname: true,
            };
        }
        if (Array.isArray(loadColumns) && loadColumns.length) {
            columnConfig = this.mergeColumn(columnConfig, loadColumns);
        }
        let extraProps = {};
        refName && (extraProps.refName = refName);
        placeholder && (extraProps.placeholder = placeholder);
        rootNode && (extraProps.rootNode = rootNode);
        columnConfig && (extraProps.columnConfig = columnConfig);
        dropDownTitleConfig &&
            (extraProps.dropDownTitleConfig = dropDownTitleConfig);
        treeConfig && (extraProps.treeConfig = treeConfig);
        addButtons && (extraProps.addButtons = addButtons);
        return <App {...others} {...extraProps} multiLang={json} />;
    }
}
export default function MultiLangWrapper(App) {
    return function Container(params) {
        return <Wrapper App={App} {...params} />;
    };
}
